import _get from 'lodash/get';
import { CategoricalColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons-ui';
import { IPermission } from 'models/settingsV2.model';

export const COL_NAMES = {
	permissionName: 'resourceName',
	permissionDescription: 'description',
	permissionActionName: 'actionName'
};

export const columnConfigs = [
	CategoricalColumn({
		title: 'Permission Name',
		mapDataToValue: (data: IPermission) => {
			return String(_get(data, COL_NAMES.permissionName, EMPTY_STRING));
		}
	}),
	CategoricalColumn({
		title: 'Permission Description',
		mapDataToValue: (data: IPermission) => {
			return String(_get(data, COL_NAMES.permissionDescription, EMPTY_STRING));
		}
	}),
	CategoricalColumn({
		title: 'Permission Action Name',
		maxWidth: 300,
		mapDataToValue: (data: IPermission) => {
			return String(_get(data, COL_NAMES.permissionActionName, EMPTY_STRING));
		}
	})
];

export interface IPermissionsSetData {
	permissionIds: string[];
	permissionSetName: string;
}

export interface IPermissionSetDetails {
	permissionsSetData: IPermissionsSetData;
}
